import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

const logError = ( error, info ) => {
	console.log( error, info );
};

function ErrorFallback( { error, resetErrorBoundary } ) {
	return (
		<div className="tw-w-full tw-h-full tw-flex-col tw-text-center tw-flex tw-items-center" role="alert">
			<p>Something went wrong:</p>
			<pre style={{ color: 'red' }}>{error.message}</pre>
		</div>
	);
}

const ErrorBoundary = ( { children } ) => {
	return (
		<ReactErrorBoundary FallbackComponent={ErrorFallback} onError={logError}>
			{children}
		</ReactErrorBoundary>
	);
};

export default ErrorBoundary;
